<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body
                    v-if="pagamento"
                >
                    <b-card-header>
                        <span class="h5">
                            REGISTRO DE PAGAMENTO DE DESPESAS
                            <b-badge variant="warning">{{ operacao }}</b-badge>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <b-row>
                            <b-col sm="12">
                                <app-k-v
                                    titulo="Protocolo"
                                    :md="md"
                                    :lg="lg"
                                    :xl="xl"
                                    ><strong>{{ pagamento.protocolo }}</strong>
                                    <app-status
                                        class="ml-1"
                                        v-if="pagamento.prioritario"
                                        status="PRIORITÁRIO"
                                    ></app-status>
                                    <app-status
                                        class="ml-1"
                                        v-if="pagamento.especial"
                                        status="ESPECIAL"
                                    ></app-status
                                ></app-k-v>
                                <app-k-v
                                    titulo="Fornecedor"
                                    :md="md"
                                    :lg="lg"
                                    :xl="xl"
                                    :dado="pagamento.fornecedor"
                                ></app-k-v>
                                <app-k-v
                                    titulo="Qtd. Despesas"
                                    :md="md"
                                    :lg="lg"
                                    :xl="xl"
                                    ><strong>{{
                                        pagamento.qtdDespesas
                                    }}</strong></app-k-v
                                >
                                <app-k-v
                                    titulo="Qtd. Anexos"
                                    :md="md"
                                    :lg="lg"
                                    :xl="xl"
                                    ><strong>{{
                                        pagamento.qtdAnexos
                                    }}</strong></app-k-v
                                >
                                <app-k-v
                                    titulo="Valor Total"
                                    :md="md"
                                    :lg="lg"
                                    :xl="xl"
                                    ><strong>{{
                                        pagamento.valorTotal | currency
                                    }}</strong></app-k-v
                                >
                                <app-k-v
                                    titulo="Status"
                                    :md="md"
                                    :lg="lg"
                                    :xl="xl"
                                    ><app-status
                                        :status="
                                            pagamento.statusDescr
                                                ? pagamento.statusDescr
                                                : ''
                                        "
                                    ></app-status>
                                    <pagamento-detalhe-reprovacao
                                        :pagamento="pagamento"
                                    ></pagamento-detalhe-reprovacao>
                                    <pagamento-detalhe-aprovacao-justificada
                                        :pagamento="pagamento"
                                    ></pagamento-detalhe-aprovacao-justificada>
                                </app-k-v>
                                <app-k-v
                                    titulo="Última Atualização"
                                    :md="md"
                                    :lg="lg"
                                    :xl="xl"
                                    ><strong>{{
                                        pagamento.dataAtualizacao
                                            ? $moment(
                                                  pagamento.dataAtualizacao
                                              ).format('DD/MM/YYYY HH:mm')
                                            : ''
                                    }}</strong></app-k-v
                                >
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <pagamento-time-line
                                    :pagamento="pagamento"
                                    :servicos="servicos"
                                    v-if="mostrarTimeLine"
                                ></pagamento-time-line>
                            </b-col>
                        </b-row>
                    </b-card-body>
                    <b-card-footer>
                        <slot name="footer" v-bind="pagamento"></slot>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import PagamentoDetalheReprovacao from './PagamentoDetalheReprovacao'
import PagamentoTimeLine from './PagamentoTimeLine.vue';
import PagamentoDetalheAprovacaoJustificada from './PagamentoDetalheAprovacaoJustificada.vue';

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        servicos: {
            type: Object,
            default: () => ({})
        },

        mostrarTimeLine: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            operacao: 'DETALHAR',
            xl: 2,
            lg: 2,
            md: 3
        }
    },

    components: {
        PagamentoDetalheReprovacao,
        PagamentoTimeLine,
        PagamentoDetalheAprovacaoJustificada
    }
}
</script>
